import { SpotTableauFileStructureViewBaseIcon } from '@tableau/icons/SpotTableauFileStructureViewBaseIcon';
import * as React from 'react';
import { View } from '../../../models/SearchResultTypes';
import { CardViewStyles } from '../CardViewStyles';
import { ContentCard, getContentUrlForItem } from '../ContentCard';
import { Thumbnail } from '../Thumbnail';
import { classNames } from '../../../../../homepage/Utils';
import { Messages } from '../../../../../gen-src/Localize';
import { CommonStyles } from '../../../../common/styles/CommonStyles';
import { ViewTooltip } from '../tooltips/ViewTooltip';
import { EntityLink, UserEntityLink } from '../../tooltips/elements/EntityLink';
import { ConnectedFavoriteToggle } from '../../Favorites/FavoriteToggle';

export const ViewCardTestID = 'ViewCard';
export const ViewCardSubSectionTestID = 'ViewCardSubSection';

export class ViewCard extends ContentCard {
  public render() {
    const viewInfo = this.props.content as View;
    return (
      <div className={classNames(CardViewStyles.Card)}>
        <Thumbnail
          navigateUrl={getContentUrlForItem(viewInfo)}
          defaultIcon={SpotTableauFileStructureViewBaseIcon}
          thumbnailImageUrl={viewInfo.thumbnailUrl}
          ariaLabel={viewInfo.name}
          onResultItemSelected={this.props.onResultItemSelected}
        />

        <div className={CardViewStyles.ActionRow} style={{ marginTop: CommonStyles.Spacing.MediumSpace }}>
          <span data-tb-test-id={ViewCardTestID} className={CardViewStyles.ActionRowName} title={viewInfo.name}>
            {viewInfo.name}
          </span>
          <span>
            <ConnectedFavoriteToggle searchResultItem={viewInfo} />
          </span>
          {this.renderInfoIconAndPopover(() => (
            <ViewTooltip content={viewInfo} urls={this.props.urls} />
          ))}
        </div>
        <div data-tb-test-id={ViewCardSubSectionTestID}>
          {viewInfo.owner && (
            <div className={CardViewStyles.SubSection}>
              {Messages.OwnerSubTitle()}{' '}
              <b>
                <UserEntityLink
                  name={viewInfo.owner.displayName}
                  href={this.props.urls.userContentUrl(viewInfo.owner.username, viewInfo.owner.domainName)}
                  styleOverride={CardViewStyles.Links}
                />
              </b>
            </div>
          )}
          {viewInfo.workbook && viewInfo.workbook.name && (
            <div className={CardViewStyles.SubSection}>
              {Messages.workbook()}{' '}
              <b>
                {
                  <EntityLink
                    name={viewInfo.workbook.name}
                    href={this.props.urls.workbookUrl(viewInfo?.workbook?.id)}
                    styleOverride={CardViewStyles.Links}
                  />
                }
              </b>
            </div>
          )}
        </div>
      </div>
    );
  }
}
